import { UserPermissions } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import DocumentsNavigationIcon from 'Icons/NavigationItem/Documents';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements';

const LazyDocumentsPage = React.lazy(() => import('./Pages/DocumentsPage'));

const documentsConfiguration: FeatureConfiguration = {
    name: 'Documents',
    navigationItem: {
        route: {
            text: 'common:sidebar.featureDocumentsTitle',
            url: '/documents',
            Icon: DocumentsNavigationIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyDocumentsPage />
                </React.Suspense>
            ),
            tenantRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyDocumentsPage />
                </React.Suspense>
            ),
        },
        permissions: [UserPermissions.ViewDocuments, UserPermissions.ViewPropertyDocuments],
    },
    disableFeature: [],
    checkIfEnabledViaSettings: (settings) => {
        if (settings && settings.documentManagement) {
            return settings.documentManagement.visible;
        }

        return false;
    },
};

export default documentsConfiguration;
